var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-base sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl",attrs:{"id":"navigation"}},[_c('nav',[_c('router-link',{attrs:{"to":{ name: _vm.changeRoute },"id":"nav-title"}},[_vm._v("jadeocr")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }